import * as React from 'react';
import { Spinner } from '@fluentui/react-components';
import loadable from '@loadable/component';
import Layout from '../layouts/ExpertLoggedIn';
import type { RedirectProps, RouteProps } from '.';

/* istanbul ignore file */

const Loading = <Spinner size="large" />;

export const routes: Array<RouteProps> = [
  {
    path: '/expert/:expertId',
    component: loadable(() => import(/* webpackChunkName: "expert-network" */ '../pages/ExpertProfilePage'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/expert',
    component: loadable(() => import(/* webpackChunkName: "expert-network" */ '../pages/EditExpertProfile'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/connection-request/:connectionRequestId',
    component: loadable(() => import(/* webpackChunkName: "expert-network" */ '../pages/FounderProfile'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
  {
    path: '/connection-requests',
    component: loadable(() => import(/* webpackChunkName: "expert-network" */ '../pages/ConnectionRequests'), {
      fallback: Loading,
    }),
    layout: Layout,
  },
];

export const redirects: Array<RedirectProps> = [
  { from: '/', to: '/connection-requests' },
  { from: '/apply', to: '/expert' },
  { from: '/settings', to: '/expert' },
];

export const NotFound = loadable(() => import(/* webpackChunkName: "404-in-ex" */ '../pages/NotFound/Expert'), {
  fallback: Loading,
});
